import { createContext } from "react";

type IAppContext = {
  activePanel: string | null;
  setActivePanel: (name: string) => void;
};

const AppContext = createContext<IAppContext>({
  activePanel: null,
  setActivePanel: (name: string) => {},
});

export default AppContext;
